import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getAccessibleUrl } from '../../modules/actions/files'
import { fileAccessibleURLSelector } from '../../modules/selectors/files'

export default function useGetAccessibleUrl() {
  const dispatch = useDispatch()

  const [fileUrl, setFileUrl] = useState('')

  const { [fileUrl]: accessibleUrl } = useSelector(fileAccessibleURLSelector)
  const isAccessibleUrlLoading = !!accessibleUrl && accessibleUrl.isLoading

  const handleFileDownloading = useCallback(
    fileUrl => {
      // all urls are private, to make them accessible for file downloading, need to get getAccessibleUrl
      if (!isAccessibleUrlLoading) {
        setFileUrl(fileUrl)
        dispatch(getAccessibleUrl(fileUrl))
      }
    },
    [dispatch, isAccessibleUrlLoading]
  )

  useEffect(() => {
    // when accessibleUrl created, start file downloading/open file in new tab
    if (fileUrl && accessibleUrl && accessibleUrl.data) {
      window.open(accessibleUrl.data)
      setFileUrl('')
    }
  }, [fileUrl, accessibleUrl])

  return {
    isAccessibleUrlLoading,
    handleFileDownloading,
    fileUrl
  }
}
